import { fluidProp, whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import HalfIconImage from './half-icon-logo-purple.png';

import { LinkButton } from '@/src/components/Button';

const HalfLogo = styled.img.attrs({
  src: HalfIconImage.src,
  alt: '',
})`
  position: absolute;
  ${fluidProp('height', '200px', '354px')}

  ${({ $position }) => {
    switch ($position) {
      case 'rightBottom':
        return css`
          right: 0;
          ${fluidProp('bottom', '-75px', '-125px')}
          z-index: -1;
        `;
      default:
        return css`
          right: 0;
          ${fluidProp('top', '-75px', '-125px')}
        `;
    }
  }}
`;

const SectionWrapper = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '150px', '130px')}
  position: relative;
  z-index: -2;
  text-align: center;

  ${({ $zIndexReset }) =>
    $zIndexReset &&
    css`
      z-index: auto;
    `}}

  ${whenProp(
    '$flippedIllustration',
    css`
      ${HalfLogo} {
        right: unset;
        left: 0;
        transform: scale(-1, 1);
      }
    `
  )}

  ${({ $tone }) => {
    switch ($tone) {
      case 'zircon':
        return css`
          background-image: var(--colors-zircon);
        `;
      default:
        return css`
          background-image: var(--colors-blank);
        `;
    }
  }}
`;

const ZirconSectionWrapper = styled(SectionWrapper)`
  && {
    background-image: var(--colors-zircon);
  }
`;

const CTATitle = styled.h1`
  ${({ theme }) => theme.typography.scale3}
  ${fluidProp(['font-size'], '24px', '42px')}
  max-width: 690px;
  color: var(--colors-irisBlue);
  margin: 0 auto;
`;

const CTADescription = styled.p`
  ${({ theme }) => theme.typography.bodyLead}
  margin: 18px auto;
  color: var(--colors-lynch);
  max-width: 690px;
`;

const CTAButton = styled(LinkButton).attrs({
  textWhite: true,
  chevron: true,
  withBorder: true,
  borderWidth: '2px',
  borderColor: 'blank',
})`
  && {
    ${({ theme }) => theme.typography.bodyLeadMedium}
    ${fluidProp('margin-top', '85px', '45px')}
  }
`;

export const PrimaryCTAButton = ({ children, ...props }) => (
  <CTAButton {...props} label={children} />
);

export const CTAWhiteBG = ({
  title = 'Discover how Remote can make international hiring easier.',
  description,
  children,
  position,
  tone,
  ...props
}) => (
  <SectionWrapper {...props} $tone={tone}>
    <HalfLogo $position={position} />
    <CTATitle>{title}</CTATitle>
    {description && <CTADescription>{description}</CTADescription>}
    {children}
  </SectionWrapper>
);
